
import CbFormDocument from "@/components/layouts/content-blocks/forms/CbFormDocument.vue";
import {CustomerContext} from "@/context/CustomerContext";
import {PageDetailModeEnum} from "@/models/enum/PageDetailModeEnum";

export default {
  computed: {
    PageDetailModeEnum() {
      return PageDetailModeEnum
    },
    CustomerContext() {
      return CustomerContext
    }
  },
  components: {CbFormDocument}
}
